/*eslint-disable*/
import React from "react";
import {isMobile} from 'react-device-detect';

function ManagerHeader() {
  return (
    <>
      <div style={{marginTop: 70}}>
        <div className="">
        {
            isMobile ? 
              window.innerWidth < 600 ? 
              (
                <img
                    alt="header-home"
                    src={require("assets/img/capa-manager-mobile.png")}
                ></img>
              ) : (
                <img
                    alt="header-home"
                    src={require("assets/img/capa-manager-1024.png")}
                ></img>
              )
            : (
              <img
                  alt="header-home"
                  src={require("assets/img/capa-manager.jpg")}
              ></img>
            )
          }
        </div>
      </div>
    </>
  );
}

export default ManagerHeader;